import { Component } from '@angular/core';

@Component({
  selector: 'ss-form-alert',
  template: `
    <div class="ss-form-alert" role="alert">
      <lucide-icon name="circle-alert" [size]="18" aria-hidden="true"></lucide-icon>
      <div><ng-content></ng-content></div>
    </div>
  `,
  styleUrl: './form-validation.component.scss',
  standalone: false
})
export class FormAlertComponent { }
